/* ============================================================
   gc diagnostics – Theme JS
   Portiert aus dem HTML-Mockup. Navigation läuft jetzt über
   echte Shopify-Seiten/Links statt eines SPA-Routers – daher
   wurde die go()-Routing-Funktion entfernt. Alle allgemeinen
   UI-Interaktionen (Menüs, Suche, Cart-Badge) bleiben erhalten.
   ============================================================ */

/* ---------- Mobiles Hauptmenü ---------- */
function toggleMobileNav(){
  const nav = document.getElementById('main-nav-list');
  const btn = document.getElementById('mobile-nav-toggle-btn');
  const willShow = !nav.classList.contains('mobile-open');
  nav.classList.toggle('mobile-open', willShow);
  if(btn) btn.setAttribute('aria-expanded', willShow ? 'true' : 'false');
}
function closeMobileNav(){
  const el = document.getElementById('main-nav-list');
  if(el) el.classList.remove('mobile-open');
  const btn = document.getElementById('mobile-nav-toggle-btn');
  if(btn) btn.setAttribute('aria-expanded', 'false');
}

/* Esc schliesst das mobile Hauptmenue und gibt den Fokus an den
   Oeffnen-Button zurueck (gleiches Muster wie bei der Suche). */
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  const nav = document.getElementById('main-nav-list');
  if(nav && nav.classList.contains('mobile-open')){
    closeMobileNav();
    const btn = document.getElementById('mobile-nav-toggle-btn');
    if(btn) btn.focus();
  }
});

/* ---------- Unternavigation (Für Neukund:innen / Bestandskund:innen) ---------- */
function toggleSubNav(id){
  document.getElementById(id).classList.toggle('mobile-sub-open');
}
function closeSubNav(){
  document.querySelectorAll('.sub-nav').forEach(el => el.classList.remove('mobile-sub-open'));
}

/* ---------- Suche im Header auf/zu ---------- */
function toggleSearch(){
  const box = document.getElementById('search-box');
  const btn = document.getElementById('search-toggle-btn');
  const willShow = !box.classList.contains('show');
  box.classList.toggle('show', willShow);
  if(btn) btn.setAttribute('aria-expanded', willShow ? 'true' : 'false');
  if(willShow){
    const input = document.getElementById('search-input');
    input.value = '';
    setTimeout(() => input.focus(), 50);
  }
}

function closeSearch(){
  const box = document.getElementById('search-box');
  if(box) box.classList.remove('show');
  const btn = document.getElementById('search-toggle-btn');
  if(btn) btn.setAttribute('aria-expanded', 'false');
}

/* Esc schliesst die Suche und gibt den Fokus zurueck an den Auf-Button –
   sonst waere die Suche mit der Tastatur zwar zu oeffnen, aber nicht mehr
   zu schliessen, ohne den Fokus zu verlieren. */
document.addEventListener('keydown', function(e){
  if(e.key !== 'Escape') return;
  const box = document.getElementById('search-box');
  if(box && box.classList.contains('show')){
    closeSearch();
    const btn = document.getElementById('search-toggle-btn');
    if(btn) btn.focus();
  }
});

/* ============================================================
   Sucheingabe mit Live-Vorschau.

   Funktioniert an jeder Stelle im Theme, nicht nur im Header:
   ein Container mit data-gc-search, darin ein Eingabefeld
   (input[name="q"]) und ein Ergebnis-Container mit
   data-gc-search-results. Der Container braucht position:relative,
   weil die Ergebnisliste absolut darunter haengt.
   Genutzt von: sections/header und der 404-Seite.
   ============================================================ */
function gcInitSearchInputs(){
  document.querySelectorAll('[data-gc-search]').forEach(function(wrap){
    const input = wrap.querySelector('input[name="q"]');
    const box = wrap.querySelector('[data-gc-search-results]');
    if(!input || !box || input.dataset.gcSearchBound) return;
    input.dataset.gcSearchBound = '1';

    let timer = null;
    input.addEventListener('input', function(){
      clearTimeout(timer);
      const query = this.value.trim();
      if(query.length < 2){
        box.innerHTML = '';
        box.classList.remove('show');
        return;
      }
      timer = setTimeout(() => gcRunPredictiveSearch(query, box), 250);
    });
  });
}
document.addEventListener('DOMContentLoaded', gcInitSearchInputs);

/* Stichtag Starterkit -> Startbonus. Kommt aus den Theme-Einstellungen
   (settings.startbonus_cutoff_date, gerendert in layout/theme.liquid als
   window.gcDiscountSettings.startbonusCutoff) - dieselbe Quelle, mit der
   die Liquid-Sections die Seiten umstellen. Fallback nur, falls das
   Settings-Skript fehlt. Ab diesem Tag setzt die Rabattautomatik
   STARTERKIT2026 nicht mehr (siehe gcEnforceMengenrabatt). */
const GC_STARTBONUS_CUTOFF = new Date(((window.gcDiscountSettings || {}).startbonusCutoff || '2026-10-01') + 'T00:00:00');

const GC_CUSTOM_SEARCH_ENTRIES = [
  { keywords: ['rechner', 'kalkulator', 'calculator', 'konfigurator'], title: 'Starterkit-Rechner', url: '/pages/igloo-starterkit' },
  { keywords: ['rechner', 'kalkulator', 'calculator', 'konfigurator', 'nachbestellung'], title: 'Nachbestellungs-Rechner', url: '/pages/bestandskund-innen' }
];

if(new Date() >= GC_STARTBONUS_CUTOFF){
  GC_CUSTOM_SEARCH_ENTRIES.push(
    { keywords: ['rechner', 'kalkulator', 'calculator', 'konfigurator', 'startbonus', 'gutschein'], title: 'Startbonus-Rechner', url: '/pages/igloo-startbonus' }
  );
}

function gcMatchCustomEntries(query){
  const q = query.trim().toLowerCase();
  if(q.length < 3) return [];
  return GC_CUSTOM_SEARCH_ENTRIES.filter(entry =>
    entry.keywords.some(k => k.includes(q) || q.includes(k))
  );
}

async function gcRunPredictiveSearch(query, box){
  box = box || document.getElementById('search-results');
  if(!box) return;
  try{
    const res = await fetch(window.Shopify.routes.root + 'search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product,page&resources[limit]=6');
    const data = await res.json();
    const products = data.resources.results.products || [];
    const pages = data.resources.results.pages || [];
    const customEntries = gcMatchCustomEntries(query);

    if(products.length === 0 && pages.length === 0 && customEntries.length === 0){
      box.innerHTML = '<div class="search-empty">Keine Ergebnisse gefunden.</div>';
      box.classList.add('show');
      return;
    }

    let html = '';
    if(customEntries.length){
      html += '<div class="search-group-label">Rechner</div>';
      customEntries.forEach(entry => {
        html += `<a class="search-result-item search-result-page" href="${entry.url}"><span class="sr-title">${entry.title}</span></a>`;
      });
    }
    if(products.length){
      html += '<div class="search-group-label">Produkte</div>';
      products.forEach(p => {
        html += `<a class="search-result-item" href="${p.url}">
          <img src="${p.featured_image ? p.featured_image.url : ''}" alt="${p.title}">
          <span>
            <span class="sr-title">${p.title}</span>
            <span class="sr-price">${p.price}</span>
          </span>
        </a>`;
      });
    }
    if(pages.length){
      html += '<div class="search-group-label">Seiten</div>';
      pages.forEach(pg => {
        html += `<a class="search-result-item search-result-page" href="${pg.url}"><span class="sr-title">${pg.title}</span></a>`;
      });
    }
    html += `<a class="search-see-all" href="${window.Shopify.routes.root}search?q=${encodeURIComponent(query)}&type=product,page">Alle Ergebnisse anzeigen →</a>`;
    box.innerHTML = html;
    box.classList.add('show');
  } catch(err){
    console.error('Suchfehler:', err);
  }
}

function toggleDownloadsCategory(catKey){
  const grid = document.getElementById('dl-grid-' + catKey);
  if(!grid) return;
  const btn = grid.previousElementSibling;
  grid.classList.toggle('show');
  if(btn) btn.classList.toggle('open');
}

document.addEventListener('click', function(e){
  const box = document.getElementById('search-box');
  if(box){
    const wrapper = box.parentElement;
    if(box.classList.contains('show') && !wrapper.contains(e.target)){
      closeSearch();
    }
  }
  /* Offene Ergebnislisten schliessen, wenn daneben geklickt wird */
  document.querySelectorAll('[data-gc-search]').forEach(function(wrap){
    const res = wrap.querySelector('[data-gc-search-results]');
    if(res && res.classList.contains('show') && !wrap.contains(e.target)){
      res.classList.remove('show');
    }
  });
  document.querySelectorAll('.info-hint.tap-active').forEach(el => {
    if(!el.contains(e.target)) el.classList.remove('tap-active');
  });
});

/* ============================================================
   Produktkacheln (Testkit-, Zubehör- und Suchergebnis-Grid):
   die Karte selbst ist per Tastatur erreichbar (tabindex="0"
   role="link" im Markup) und wird hier mit Enter/Leertaste
   bedienbar gemacht, genau wie ein Klick mit der Maus.
   ============================================================ */
function gcCardActivate(e, url){
  if(e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
  e.preventDefault();
  window.location.href = url;
}

/* ============================================================
   W-17: kleine, zum Design passende Fehlermeldung statt alert().

   Statt des grauen Browser-Popups erscheint unten mittig ein
   navyfarbenes Banner (passend zu .btn-navy), mit Warn-Icon,
   Schließen-Button und automatischem Ausblenden.
   role="alert" + aria-live="assertive" sorgen dafür, dass ein
   Screenreader die Meldung trotzdem sofort ankündigt - der
   eigentliche Grund, warum alert() als "schlecht angebunden"
   im Audit auffiel, bleibt also behoben, nur ohne den
   blockierenden System-Dialog. Wird von einer einzigen
   Toast-Instanz bedient (mehrere Fehler kurz nacheinander
   ersetzen einander statt sich zu stapeln - für diesen Shop
   reicht das).

   30.09.2026: Anzeigedauer richtet sich nach der Textlänge
   (mind. 5 s), damit längere Hinweise lesbar bleiben.
   ============================================================ */
function gcEnsureErrorToast(){
  let toast = document.getElementById('gc-error-toast');
  if(toast) return toast;

  toast = document.createElement('div');
  toast.id = 'gc-error-toast';
  toast.setAttribute('role', 'alert');
  toast.setAttribute('aria-live', 'assertive');
  Object.assign(toast.style, {
    position: 'fixed',
    left: '50%',
    bottom: '28px',
    transform: 'translate(-50%, 14px)',
    zIndex: '9999',
    display: 'flex',
    alignItems: 'flex-start',
    gap: '10px',
    maxWidth: 'min(92vw, 420px)',
    background: '#13293D',
    color: '#fff',
    padding: '14px 16px',
    borderRadius: '10px',
    boxShadow: '0 10px 28px rgba(19,41,61,.32)',
    fontFamily: "'Lexend', sans-serif",
    fontSize: '14px',
    lineHeight: '1.45',
    opacity: '0',
    transition: 'opacity .22s ease, transform .22s ease',
    pointerEvents: 'none'
  });
  toast.innerHTML =
    '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#fff" stroke-width="2" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" style="flex-shrink:0;margin-top:1px;">' +
    '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12.5"/><circle cx="12" cy="16" r="0.5" fill="#fff"/>' +
    '</svg>' +
    '<span id="gc-error-toast-text" style="flex:1;"></span>' +
    '<button type="button" aria-label="Meldung schließen" style="background:none;border:none;color:#fff;' +
    'opacity:.7;cursor:pointer;font-size:18px;line-height:1;padding:0;margin-left:4px;flex-shrink:0;">&times;</button>';

  toast.querySelector('button').addEventListener('click', gcHideErrorToast);
  document.body.appendChild(toast);
  return toast;
}

function gcShowError(message){
  const toast = gcEnsureErrorToast();
  clearTimeout(toast._gcHideTimer);
  toast.querySelector('#gc-error-toast-text').textContent = message;
  toast.style.pointerEvents = 'auto';
  requestAnimationFrame(() => {
    toast.style.opacity = '1';
    toast.style.transform = 'translate(-50%, 0)';
  });
  const duration = Math.max(5000, String(message || '').length * 70);
  toast._gcHideTimer = setTimeout(gcHideErrorToast, duration);
}

function gcHideErrorToast(){
  const toast = document.getElementById('gc-error-toast');
  if(!toast) return;
  clearTimeout(toast._gcHideTimer);
  toast.style.opacity = '0';
  toast.style.transform = 'translate(-50%, 14px)';
  toast.style.pointerEvents = 'none';
}

/* ============================================================
   POS-Material im Warenkorb (Stand 22.10.2026, Entscheidung Sales)

   Liegt mindestens ein Igloo-Gerät im Warenkorb, ist GENAU EIN
   POS-Paket kostenlos (Basis ODER Premium, nach Wahl) – in allen
   Shops und Partnerbereichen, unabhängig von der Anzahl Testboxen
   und vom Weg, über den die Artikel in den Warenkorb kamen. (Bis
   21.10.2026 brauchte es zusätzlich 3 Testboxen.) Ausnahme: im
   Dental-Modus gibt es gar kein POS-Material (gc-dental.js entfernt
   es). Jedes weitere POS-Paket läuft über
   die reguläre Variante und wird voll berechnet. Die regulären
   POS-Produkte liegen in keiner Rabatt-Collection, Staffel- und
   Starterkit-Rabatt greifen dort also nicht.

   Die Automatik stellt bei jeder Warenkorbänderung her:
   - nicht berechtigt: alle kostenlosen Einheiten -> regulär
   - berechtigt: insgesamt genau 1 kostenlose Einheit. Überzählige
     kostenlose Einheiten -> regulär (gleiches Paket). Gibt es noch
     keine kostenlose, wird eine reguläre Einheit umgewandelt.
   Die Gesamtzahl der POS-Pakete ändert sich dabei nie.

   Die kostenlose Zeile hat im Warenkorb keinen Stepper
   (snippets/cart-line.liquid). Die Varianten-IDs dort müssen zu
   GC_POS_VARIANTS passen.
   ============================================================ */
const GC_POS_VARIANTS = {
  basis:   { paid: 59102690869573, free: 59102690902341 },
  premium: { paid: 59102691787077, free: 59102691819845 }
};
const GC_POS_FREE_MAX = 1;

/* Reine Rechnung, ohne Netzwerk: aktuelle Mengen je Variante rein,
   gewünschte Mengen je Variante raus (nur die, die sich ändern). */
function gcPosTargetUpdates(qtyByVariant, eligible){
  const keys = Object.keys(GC_POS_VARIANTS);
  const target = {};
  keys.forEach(k => {
    const p = GC_POS_VARIANTS[k];
    target[k] = { paid: qtyByVariant[p.paid] || 0, free: qtyByVariant[p.free] || 0 };
  });

  let freeLeft = eligible ? GC_POS_FREE_MAX : 0;

  /* 1. Vorhandene kostenlose Einheiten auf das Kontingent kürzen */
  keys.forEach(k => {
    const t = target[k];
    const keep = Math.min(t.free, freeLeft);
    t.paid += t.free - keep;
    t.free = keep;
    freeLeft -= keep;
  });

  /* 2. Kontingent noch offen: reguläre Einheit umwandeln */
  keys.forEach(k => {
    const t = target[k];
    if(freeLeft > 0 && t.paid > 0){
      const n = Math.min(t.paid, freeLeft);
      t.paid -= n;
      t.free += n;
      freeLeft -= n;
    }
  });

  const updates = {};
  keys.forEach(k => {
    const p = GC_POS_VARIANTS[k];
    const t = target[k];
    if(t.paid !== (qtyByVariant[p.paid] || 0)) updates[p.paid] = t.paid;
    if(t.free !== (qtyByVariant[p.free] || 0)) updates[p.free] = t.free;
  });
  return updates;
}

async function gcEnforcePosFreebie(){
  try{
    const res = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await res.json();

    let deviceQty = 0;
    let testboxQty = 0;
    const qtyByVariant = {};
    cart.items.forEach(item => {
      if(item.product_type === 'Geraet') deviceQty += item.quantity;
      if(item.product_type === 'Testkit') testboxQty += item.quantity;
      qtyByVariant[item.variant_id] = (qtyByVariant[item.variant_id] || 0) + item.quantity;
    });
    /* Seit 22.10.2026: Igloo im Warenkorb genuegt (testboxQty bleibt
       nur zur Info gezaehlt). */
    const eligible = deviceQty >= 1;

    const updates = gcPosTargetUpdates(qtyByVariant, eligible);
    if(Object.keys(updates).length === 0) return;

    /* Ein einziger Request: update.js setzt Mengen je Varianten-ID
       und legt fehlende Varianten automatisch neu an. */
    const upd = await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ updates })
    });
    if(!upd.ok) throw new Error('cart/update.js ' + upd.status);

    await gcRefreshCartSection();
  } catch(err){
    console.error('POS-Freebie-Check fehlgeschlagen:', err);
  }
}


/* ============================================================
   Rabatte im Warenkorb.

   Zwei Ebenen, die sich in Shopify NICHT ins Gehege kommen:

   1. Staffelrabatte (unsere Automatik) sind Produktrabatte auf
      Collections: NACHBESTELLUNG5/10 auf "testkits_neu",
      STARTERKIT2026 auf "starterkit-bundle-gerat-testkits".
   2. Gutscheine (z. B. der Startbonus-Gutschein) sind
      Bestellrabatte auf die Gesamtsumme.

   Beide Klassen sind in Shopify als kombinierbar markiert
   ("Kann mit Bestellrabatten kombiniert werden" bzw. umgekehrt).
   Deshalb darf die Automatik einen von Kund:innen eingegebenen
   Code NICHT mehr überschreiben: sie tauscht ausschliesslich
   ihren eigenen Staffel-Code aus und schickt alle uebrigen
   Codes unveraendert mit. /cart/update.js nimmt dafuer mehrere
   Codes komma-getrennt.

   WICHTIG bei neuen Gutscheinen: In Shopify unter Rabatte muss
   "Kombinationen -> Produktrabatte" angehakt sein, sonst gilt
   am Ende nur einer der beiden Rabatte.
   ============================================================ */
const GC_MENGENRABATT_CODES = ['NACHBESTELLUNG5', 'NACHBESTELLUNG10', 'STARTERKIT2026'];

/* B-07: Schwellen/Prozentsaetze kommen jetzt ausschliesslich aus
   window.gcDiscountSettings (gerendert in layout/theme.liquid aus den
   globalen Theme-Einstellungen "Mengenrabatt-Schwellen"). Vorher standen
   dieselben Zahlen zusaetzlich hart codiert hier UND als eigene
   Section-Einstellung in den Rechnern – zwei Stellen, die man beim
   Pflegen leicht auseinanderlaufen lassen konnte. Die Fallback-Werte
   unten greifen nur, falls das Settings-Skript aus irgendeinem Grund
   nicht geladen wurde, und entsprechen den bisherigen hart codierten
   Werten. */
function gcDiscountThresholds(){
  const cfg = window.gcDiscountSettings || {};
  return {
    starterkitMinBoxes: cfg.starterkitMinBoxes || 5,
    nachbestellungTier1Boxes: cfg.nachbestellungTier1Boxes || 5,
    nachbestellungTier2Boxes: cfg.nachbestellungTier2Boxes || 10
  };
}

function gcCartCodes(cart){
  return (cart.discount_codes || []).map(d => d.code);
}

function gcSameCodes(a, b){
  if(a.length !== b.length) return false;
  return a.every(c => b.indexOf(c) !== -1);
}

async function gcWriteDiscountCodes(codes){
  return fetch(window.Shopify.routes.root + 'cart/update.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ discount: codes.join(',') })
  });
}

async function gcEnforceMengenrabatt(){
  try{
    const { starterkitMinBoxes, nachbestellungTier1Boxes, nachbestellungTier2Boxes } = gcDiscountThresholds();

    const res = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await res.json();

    let deviceQty = 0;
    let testboxQty = 0;
    cart.items.forEach(item => {
      if(item.product_type === 'Geraet') deviceQty += item.quantity;
      if(item.product_type === 'Testkit') testboxQty += item.quantity;
    });

    /* Ab dem Startbonus-Stichtag gibt es keinen Starterkit-Rabatt mehr:
       STARTERKIT2026 wird dann weder gesetzt noch behalten (der Code endet
       in Shopify ebenfalls am 30.09.2026, 23:59 Uhr). Ein Warenkorb mit
       Geraet bekommt danach keinen Staffelcode - die Nachbestellungs-
       Staffel gilt weiterhin nur ohne Geraet. */
    const starterkitActive = new Date() < GC_STARTBONUS_CUTOFF;

    let targetCode = null;
    if(starterkitActive && deviceQty >= 1 && testboxQty >= starterkitMinBoxes){
      targetCode = 'STARTERKIT2026';
    } else if(deviceQty === 0 && testboxQty >= nachbestellungTier2Boxes){
      targetCode = 'NACHBESTELLUNG10';
    } else if(deviceQty === 0 && testboxQty >= nachbestellungTier1Boxes){
      targetCode = 'NACHBESTELLUNG5';
    }

    const current = gcCartCodes(cart);
    /* Alles, was nicht unsere Staffel ist, bleibt unangetastet. */
    const manual = current.filter(c => GC_MENGENRABATT_CODES.indexOf(c) === -1);
    const desired = (targetCode ? [targetCode] : []).concat(manual);

    if(gcSameCodes(desired, current)) return;

    await gcWriteDiscountCodes(desired);
    await gcRefreshCartSection();
  } catch(err){
    console.error('Mengenrabatt-Check fehlgeschlagen:', err);
  }
}

/* Gutschein hinzufuegen, ohne die Staffel oder andere Codes zu verlieren.
   Rueckgabe: true, wenn Shopify den Code angenommen hat. */
async function gcAddDiscountCode(code){
  code = (code || '').trim();
  if(!code) return false;

  const res = await fetch(window.Shopify.routes.root + 'cart.js');
  const cart = await res.json();
  const current = gcCartCodes(cart);
  if(current.some(c => c.toLowerCase() === code.toLowerCase())) return true;

  await gcWriteDiscountCodes(current.concat([code]));

  const res2 = await fetch(window.Shopify.routes.root + 'cart.js');
  const cart2 = await res2.json();
  const accepted = gcCartCodes(cart2).some(c => c.toLowerCase() === code.toLowerCase());

  await gcRefreshCartSection();
  return accepted;
}

/* Einzelnen Code entfernen, die uebrigen behalten. */
async function gcRemoveDiscountCode(code){
  const res = await fetch(window.Shopify.routes.root + 'cart.js');
  const cart = await res.json();
  const rest = gcCartCodes(cart).filter(c => c.toLowerCase() !== (code || '').toLowerCase());
  await gcWriteDiscountCodes(rest);
  await gcRefreshCartSection();
}

async function gcRefreshCartSection(){
  const current = document.getElementById('gc-cart-section-content');
  if(!current) return;
  try{
    const res = await fetch(window.Shopify.routes.root + 'cart?sections=main-cart');
    const data = await res.json();
    const parser = new DOMParser();
    const doc = parser.parseFromString(data['main-cart'], 'text/html');
    const newContent = doc.getElementById('gc-cart-section-content');
    if(newContent) current.innerHTML = newContent.innerHTML;
    gcUpdateCartBadge();
  } catch(err){ console.error(err); }
}


/* ============================================================
   Shopify Cart-API – ersetzt die cartItems-Simulation aus dem
   Mockup. Alle "In den Warenkorb legen"-Buttons rufen
   gcAddItemsToCart(items) auf, mit echten Varianten-IDs.
   items = [{ id: <variant_id>, quantity: <n>, properties?: {} }]

   Fix 30.09.2026: Lehnt Shopify das Hinzufügen ab (meist 422,
   weil eine Variante auf "nicht weiterverkaufen" steht und der
   Bestand kleiner als die gewählte Menge ist), zeigte der Shop
   bisher eine Entwickler-Meldung ("Bitte prüfen, ob alle
   Varianten korrekt hinterlegt sind"). Jetzt wird Shopifys
   eigene, deutschsprachige Begründung angezeigt - die nennt
   Produkt und verfügbare Menge -, ergänzt um einen Hinweis für
   Kund:innen. Die technische Antwort steht weiter in der Konsole.
   Kein Teil-Hinzufügen: cart/add.js mit mehreren items ist
   ohnehin alles-oder-nichts.
   ============================================================ */
function gcCartAddErrorMessage(status, err){
  const desc = (err && typeof err.description === 'string') ? err.description.trim() : '';
  if(status === 422){
    const reason = desc || 'Mindestens ein Artikel ist in der gewählten Menge gerade nicht verfügbar.';
    return reason + ' Bitte die Menge anpassen. Für größere Mengen melden Sie sich gern direkt bei uns.';
  }
  if(status === 404){
    return 'Ein Artikel ist nicht mehr im Sortiment. Bitte laden Sie die Seite neu und versuchen Sie es erneut.';
  }
  return 'Der Warenkorb konnte gerade nicht aktualisiert werden. Bitte versuchen Sie es in einem Moment erneut.';
}

async function gcAddItemsToCart(items, attributes){
  items = items.filter(i => i.quantity > 0 && i.id);
  if(items.length === 0) return null;
  const body = { items };
  if(attributes) body.attributes = attributes;

  let res;
  try{
    res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    });
  } catch(netErr){
    console.error('Cart-Add-Netzwerkfehler:', netErr);
    gcShowError('Keine Verbindung zum Warenkorb. Bitte prüfen Sie Ihre Internetverbindung und versuchen Sie es erneut.');
    return null;
  }

  if(!res.ok){
    const err = await res.json().catch(() => ({}));
    console.error('Cart-Add-Fehler:', res.status, err, items);
    gcShowError(gcCartAddErrorMessage(res.status, err));
    return null;
  }
  const added = await res.json();
  await gcUpdateCartBadge();
  await gcEnforcePosFreebie();
  await gcEnforceMengenrabatt();
  return added;
}

async function gcUpdateCartBadge(){
  try{
    const res = await fetch(window.Shopify.routes.root + 'cart.js');
    const cart = await res.json();
    const badge = document.getElementById('cart-badge-count');
    if(!badge) return;
    if(cart.item_count > 0){
      badge.textContent = cart.item_count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  } catch(err){ console.error(err); }
}

/* ---------- Info-Hint-Tooltips (z. B. "fachkundige Person", Lanzetten-Hinweis) ---------- */
/* Werden direkt per onclick="event.stopPropagation(); this.classList.toggle('tap-active')"
   in den jeweiligen Snippets ausgelöst – siehe snippets/info-hint.liquid */

/* ============================================================
   Desktop-Hover-Vorschau (Bild + Preis + Kurzbeschreibung) bei
  "Informationen"-Links in den Rechnern und Untermenüs.
   Nur auf Desktop mit echter Maus (hover: hover + pointer: fine),
   siehe CSS: @media (max-width:900px){ .gc-hover-preview{display:none} }
   ============================================================ */
function gcCanHoverPreview(){
  return window.matchMedia('(hover: hover) and (pointer: fine)').matches && window.innerWidth > 900;
}

let gcPreviewTimer = null;

function gcRenderPreview(evt, data){
  if(!gcCanHoverPreview()) return;
  clearTimeout(gcPreviewTimer);
  const card = document.getElementById('gc-hover-preview');
  if(!card) return;
  card.classList.toggle('size-large', data.size === 'large');
  document.getElementById('ghp-img').src = data.image || '';
  document.getElementById('ghp-img').alt = data.title || '';
  document.getElementById('ghp-title').textContent = data.title || '';
  document.getElementById('ghp-price').textContent = data.price || '';
  document.getElementById('ghp-desc').textContent = data.desc || '';

  // Zielseite der Karte setzen, damit ein Klick auf die Karte zur
  // Produktseite führt. Ohne URL wird der Klick neutralisiert und
  // die Detail-Zeile ausgeblendet.
  const cta = card.querySelector('.ghp-cta');
  if(data.url){
    card.setAttribute('href', data.url);
    if(cta) cta.style.display = '';
  } else {
    card.setAttribute('href', '#');
    if(cta) cta.style.display = 'none';
  }

  const rect = evt.currentTarget.getBoundingClientRect();
  let left = rect.right + 16;
  let top = rect.top - 20;
  if(left + 280 > window.innerWidth - 10) left = rect.left - 296;
  if(top + 320 > window.innerHeight) top = window.innerHeight - 330;
  if(top < 10) top = 10;
  card.style.left = left + 'px';
  card.style.top = top + 'px';
  card.classList.add('show');
}

function gcHidePreview(){
  gcPreviewTimer = setTimeout(() => {
    const card = document.getElementById('gc-hover-preview');
    if(card) card.classList.remove('show');
  }, 180);
}

/* ------------------------------------------------------------
   Cursor-Brücke zur Vorschaukarte: Wenn die Maus von einem
   "Informationen"-Link zur Karte selbst wandert, soll die Karte
   NICHT verschwinden, damit man den "Klicken für alle Details"-
   Link erreichen kann. Die Karte fängt den ausstehenden
   Ausblend-Timer ab (mouseenter) und blendet erst beim echten
   Verlassen wieder aus (mouseleave). Einmalig registriert.
   ------------------------------------------------------------ */
function gcInitPreviewBridge(){
  const card = document.getElementById('gc-hover-preview');
  if(!card || card.dataset.bridgeReady) return;
  card.dataset.bridgeReady = '1';
  card.addEventListener('mouseenter', () => { clearTimeout(gcPreviewTimer); });
  card.addEventListener('mouseleave', () => { gcHidePreview(); });
  // Klick auf die Karte ohne echtes Ziel abfangen
  card.addEventListener('click', (e) => {
    if(card.getAttribute('href') === '#'){ e.preventDefault(); }
  });
}
document.addEventListener('DOMContentLoaded', gcInitPreviewBridge);


/* ============================================================
   Warenkorb-Zeilen: Menge ändern und Position ganz entfernen.

   Adressiert wird über item.key (String der Form "<variant>:<hash>").
   Eine laufende Zeilennummer wäre falsch, weil der Warenkorb die
   Positionen nach Produkttyp umsortiert anzeigt. Alte Aufrufe mit
   einer Zahl funktionieren weiterhin (dann als "line").
   ============================================================ */
function gcCartChangeBody(ref, qty){
  const body = {
    quantity: qty,
    sections: 'main-cart',
    sections_url: window.location.pathname
  };
  if(typeof ref === 'string' && ref.indexOf(':') !== -1){
    body.id = ref;
  } else {
    body.line = ref;
  }
  return body;
}

async function gcApplyCartChange(ref, qty){
  const consentBox = document.getElementById('cart-consent');
  const wasChecked = consentBox ? consentBox.checked : false;

  const res = await fetch(window.Shopify.routes.root + 'cart/change.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify(gcCartChangeBody(ref, qty))
  });
  if(!res.ok) throw new Error('Cart update failed');
  const data = await res.json();

  const sectionHtml = data.sections['main-cart'];
  const parser = new DOMParser();
  const doc = parser.parseFromString(sectionHtml, 'text/html');
  const newContent = doc.getElementById('gc-cart-section-content');
  const current = document.getElementById('gc-cart-section-content');
  if(newContent && current){
    current.innerHTML = newContent.innerHTML;
  }

  const newConsentBox = document.getElementById('cart-consent');
  if(newConsentBox && wasChecked){
    newConsentBox.checked = true;
    const checkoutBtn = document.getElementById('checkout-btn');
    if(checkoutBtn) checkoutBtn.disabled = false;
  }

  const badge = document.getElementById('cart-badge-count');
  if(badge){
    if(data.item_count > 0){
      badge.textContent = data.item_count;
      badge.style.display = 'flex';
    } else {
      badge.style.display = 'none';
    }
  }

  await gcEnforcePosFreebie();
  await gcEnforceMengenrabatt();
}

async function gcAdjustCartItem(evt, ref, delta){
  const stepper = evt.currentTarget.closest('.stepper');
  const qtySpan = stepper.querySelector('span');
  let qty = parseInt(qtySpan.textContent, 10) + delta;
  if(qty < 0) qty = 0;

  try{
    await gcApplyCartChange(ref, qty);
  } catch(err){
    console.error('Warenkorb-Fehler:', err);
    gcShowError('Menge konnte nicht geändert werden.');
  }
}

/* Ganze Position auf einen Klick entfernen (Papierkorb-Button) */
async function gcRemoveCartItem(evt, ref){
  const btn = evt.currentTarget;
  const row = btn.closest('.cart-item');
  btn.disabled = true;
  if(row) row.classList.add('is-removing');

  try{
    await gcApplyCartChange(ref, 0);
  } catch(err){
    console.error('Warenkorb-Fehler:', err);
    btn.disabled = false;
    if(row) row.classList.remove('is-removing');
    gcShowError('Position konnte nicht entfernt werden.');
  }
}

/* ============================================================
   W-16: Warenkorb-Prüfungen laufen nicht mehr bei jedem
   Seitenaufruf.

   Vorher hingen gcUpdateCartBadge(), gcEnforcePosFreebie() und
   gcEnforceMengenrabatt() auf jeder Seite an DOMContentLoaded —
   drei Requests pro Aufruf, auch auf Rechtstexten und der
   404-Seite, wo es nichts zu prüfen gibt.

   Der Kontext kommt aus layout/theme.liquid:
     window.gcCartContext = { cartRelevant, itemCount }
   cartRelevant ist false auf der 404-Seite und den Rechtstexten,
   itemCount ist die serverseitig gerenderte Artikelzahl.

   Die Badge-Zahl rendert sections/header.liquid bereits selbst
   aus cart.item_count — der Abruf beim Laden war reine Dopplung.
   gcUpdateCartBadge() bleibt für die AJAX-Fälle unverändert
   erhalten und wird von gcApplyCartChange() und
   gcAddItemsToCart() weiter aufgerufen.

   Sicherheitsnetz: jede Warenkorbänderung ruft beide Prüfungen
   selbst auf, und die Warenkorbseite ist nie ausgeschlossen. Vor
   dem Checkout läuft die Automatik damit in jedem Fall.

   Fehlt gcCartContext (z. B. veraltetes Layout im Cache), gilt
   das alte Verhalten — dann ist keines der Felder gesetzt.
   ============================================================ */
function gcShouldRunCartChecks(){
  const ctx = window.gcCartContext || {};
  if(ctx.cartRelevant === false) return false;
  if(ctx.itemCount === 0) return false;
  return true;
}

document.addEventListener('DOMContentLoaded', function(){
  if(!gcShouldRunCartChecks()) return;
  gcEnforcePosFreebie();
  gcEnforceMengenrabatt();
});
